import React from 'react';
import { Flex, Link, Heading, Text } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons'

function VoiceView({ data }) {
    return (

            <Flex
                p="10px"
                mt="20px"
                borderRadius="10px"
                width="80%"
                height="80%"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
            >
                <Heading>Voice Interaction</Heading>
                <Text mt="25px">Follow the link below to open the Amazon Connect contact record and view the interaction details, observe call/screen recordings or perform quality evaluations.</Text>
                <Link mt="25px" href={data} isExternal>
                    Open AWS Contact Record <ExternalLinkIcon mx='2px' />
                </Link>
            </Flex>
    );
}

export default VoiceView;
